import {Injectable} from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EventCountDownTimerUtil {
	eventTime: any;
	currentTime = moment().unix();
	diffTime: any;
	duration: any;
	interval = 1000;
	timer = {total: 0, days: 0, hours: 0, minutes: 0, seconds: 0};
	timeinterval: any;
	private timerSubject = new BehaviorSubject({total: 0, days: 0, hours: 0, minutes: 0, seconds: 0});
	timer$ = this.timerSubject.asObservable();

	constructor() {
	}

	startCountDown(eventTime) {
		const that = this;
		this.updateTimer(eventTime);
		this.timeinterval = setInterval(() => {
			this.timer = this.getTimeRemaining(eventTime);
			this.timerSubject.next(this.timer);
			if (this.timer.total <= 0) {
				clearInterval(this.timeinterval);
			}
		}, 1000);
	}

	updateTimer(endtime) {
		this.timer = this.getTimeRemaining(endtime);
		if (this.timer.total <= 0) {
			clearInterval(this.timeinterval);
		}
	}

	getTimeRemaining(endtime) {
		const newDate = new Date(endtime).toISOString();
		const total = Date.parse(newDate.toString()) - Date.parse(new Date().toString());
		const seconds = Math.floor((total / 1000) % 60);
		const minutes = Math.floor((total / 1000 / 60) % 60);
		const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
		const days = Math.floor(total / (1000 * 60 * 60 * 24));
		if (total <= 0) {
			return {total: 0, days: 0, hours: 0, minutes: 0, seconds: 0};
		}
		return {total, days, hours, minutes, seconds};
	}

	reset() {
		clearInterval(this.timeinterval);
		this.timer = {total: 0, days: 0, hours: 0, minutes: 0, seconds: 0};
	}

}
